export const RANK_MAP: {[key: string]: string} = {
// Air Force
  'General':	'Gen',
  'Lieutenant General': 'Lt Gen',
  'Major General': 'Maj Gen',
  'Brigadier General': 'Brig Gen',
  'Colonel': 'Col',
  'Lieutenant Colonel':	'Lt Col',
  'Major':	'Maj',
  'Captian':	'Capt',
  'First Lieutenant': '1st Lt',
  'Second Lieutenant': '2nd Lt',
  'Chief Master Sergeant of the Air Force':	'CMSAF',
  'Chief Master Sergeant':	'CMSgt',
  'Senior Master Sergeant':	'SMSgt',
  'Master Sergeant':	'MSgt',
  'Technical Sergeant':	'TSgt',
  'Staff Sergeant':	'SSgt',
  'Senior Airman':	'SrA', 
  'Airman First Class':	'A1C',
  'Airman':	'Amn',
  'Airman Basic':	'AB',
// Navy
  'Admiral': 'ADM',
  'Vice Admiral':	'VADM',
  'Rear Admiral':	'RADM',
  'Captain':	'CAPT',
  'Commander': 'CDR',
  'Lieutenant Commander':	'CLDR',
  'Lieutenant':	'LT',
  'Lieutenant Junior Grade': 'LTJG',
  'Ensign': 'ENS',
  'Chief Warrant Officer 4': 'CWO4',
  'Chief Warrant Officer 3': 'CWO3',
  'Chief Warrant Officer 2':	'CWO2',
  'Warrant Officer':	'WO1',
  'Master Chief Petty Officer of the Navy':	'MCPON',
  'Master Chief Petty Officer':	'MCPO',
  'Senior Chief Petty Officer':	'SCPO',
  'Chief Petty Officer':	'CPO',
  'Petty Officer 1':	'PO1',
  'Petty Officer 2':	'PO2',
  'Petty Officer 3':	'PO3',
  'Seaman':	'SN',
  'Seaman Apprentice': 'SA',
  'Seaman Recruit':	'SR',
// Army
  // 'General': 'GEN',
  // 'Lieutenant General': 'LTG',
  // 'Major General': 'MG',
  // 'Brigadier General': 'BG',
  // 'Colonel': 'COL',
  // 'Lieutenant Colonel': 'LTC',
  // 'Major': 'MAJ',
  // 'Captain': 'CPT',
  // 'First Lieutenant': '1LT',
  // 'Second Lieutenant': '2LT',
  // 'Chief Warrant Officer':	'CW51',
  // 'Chief Warrant Officer 4':	'CW4',
  // 'Chief Warrant Officer 3':	'CW3',
  // 'Chief Warrant Officer 2':	'CW2',
  'Warrant Officer 1':	'WO1',
  'Sergeant Major of the Army':	'SMA',
  'Command Sergeant Major':	'CSM',
  'Sergeant Major':	'SGM',
  'First Sergeant':	'1SG',
  // 'Master Sergeant':	'MSG',
  'Sergeant First Class':	'SFC',
  // 'Staff Sergeant':	'SSG',
  'Sergeant':	'SGT',
  'Corporal':	'CPL',
  'Specialist':	'SPC',
  'Private First Class':	'PFC',
  'Private':	'PVT',
// Marine Corp
  // 'General': 'Gen',
  // 'Lieutenant General':	'LtGen',
  // 'Major General': 'MajGen',
  // 'Brigadier General': 'BGen',
  // 'Colonel': 'Col',
  // 'Lieutenant Colonel': 'LtCol',
  // 'Major': 'Maj',
  // 'Captain': 'Capt',
  // 'First Lieutenant': '1st Lt',
  // 'Second Lieutenant': '2nd Lt',
  'Chief Warrant Officer 5': 'CWO-5',
  'chief Warrant Officer 4': 'CWO-4',
  // 'Chief Warrant Officer 3': 'CWO-3',
  // 'Chief Warrant Officer 2': 'CWO-2',
  // 'Chief Warrant Officer 1': 'CWO-1',
  'Sergeant Major of the Marine Corps': 'SgtMajMC',
  // 'Sergeant Major': 'Sgt Maj',
  'Master Gunnery Sergeant': 'MGySgt',
  // 'First Sergeant': '1stSgt',
  // 'Master Sergeant': 'MSgt',
  'Gunnery Sergeant': 'GySgt',
  // 'Staff Sergeant': 'SSgt',
  'SErgeant': 'Sgt',
  // 'Corporal': 'Cpl',
  'Lance Corporal': 'LCpl',
  // 'Private First Class': 'PFC',
  // 'Private': 'Pvt',
}

export function shortRank(rank: string): string {
  return RANK_MAP[rank] || rank
}